export default __webpack_public_path__ + "static/media/circle_success.aad85f85.svg";